module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "copy",
    attrs: {
      "id": "copy"
    }
  }, [_vm._v("Copyright © 2003 by Iain Levison")]), _vm._v(" "), _c('p', {
    staticClass: "ser1",
    staticStyle: {
      "margin-top": "2%"
    }
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Published by")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Soho Press Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("853 Broadway")]), _vm._v(" "), _c('p', {
    staticClass: "ser1"
  }, [_vm._v("New York, NY 10003")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data Levison, Iain.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Since the layoffs : a novel / Iain Levison. p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("ISBN 1-56947-335-8 (alk. paper)"), _c('br'), _vm._v("eISBN 978-1-56947-921-6")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("1. Young men—Fiction. 2. Unemployed—Fiction.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("3. Criminals—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("PS3612.E837S56 2003")]), _vm._v(" "), _c('p', {
    staticClass: "ser1"
  }, [_vm._v("813’.6—dc21    2002044654")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e5b83a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c5.vue
// module id = 66
// module chunks = 0